import { Maintenance } from "@/pages/errorPages/maintenance";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/maintenance")({
  component: Maintenance,
});
